import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JWTUser } from '@models/jwt-data.model';
import { UserBusinessType } from '@app/shared/models/enums/user-business-type.enum';

@Injectable()
export class NavigationService {
  private history: string[] = [];

  constructor(private router: Router) {}

  addToHistory(url: string) {
    this.history.push(url);
  }

  getPreviousUrl(): string | null {
    return this.history.pop() || null;
  }

  clearHistory(): void {
    this.history = [];
  }

  navigateToDefaultRoute(user: JWTUser, replaceUrl = false): void {
    if (!user) {
      return;
    }

    const extras = { replaceUrl };

    switch (user.userBusinessType) {
      case UserBusinessType.TechnicalToolManagementUser:
        this.router.navigate(['/dashboard'], extras);
        return;
      case UserBusinessType.TechnicalProductionUser:
        this.router.navigate(['/scan-badge'], extras);
        return;
      default:
        switch (user.role) {
          case 'ATOM_Transport':
            this.router.navigate(['/transportation-requests'], extras);
            break;
          case 'ATOM_Service':
            this.router.navigate(['/service-tickets'], { ...extras, queryParams: { type: 'all' } });
            break;
          default:
            this.router.navigate(['/'], extras);
            break;
        }
    }
  }

}
